import http from "../../http";
import ApiConstants from '../../constants/ApiConstants';
import moment from "moment";

export const TIMESHEET_CONSTANTS = {
    DRAFT: 'DRAFT',
    APPROVE: "APPROVE",
    APPROVED: 'APPROVED',
    REJECT: "REJECT",
    REJECTED: "REJECTED",
    SUBMITTED: "SUBMITTED",
    DELETE: "DELETE"
}

class TimesheetService {
    static PROJECT = null;
    static TASK = null;
    static EMPLOYEE_MAPPING = null;
    static TIMESHEET_ENTRY = null;
    static ENTRY_DATE = null;
    static REPORT = null;

    static CUSTOMERS = [
        { value: "10b734520a2aaa7131f2c57a", label: "Tom Brady" },
        { value: "20b734520a2aaa7131f2c57b", label: "ABDALLAH ZAID" },
        { value: "30b734520a2aaa7131f2c57c", label: "Flelicity Howard" },
        { value: "40b734520a2aaa7131f2c57d", label: "Simon Chau" }
    ];
    static PROJECTS_DATA = [
        { id: "10b734520a", name: "Project 1", code: "P1", customer: "10b734520a2aaa7131f2c57a", isBillable: true, class: "AA" }
    ];
    static TASKS_DATA = [
        { id: "10b734520b", name: "Task 1", description: "Task 1", projectId: "10b734520a", isBillable: true },
        { id: "10b734520c", name: "Task 2", description: "Task 2", projectId: "10b734520a", isBillable: false }
    ];
    static MAPPING_DATA = [];
    static TIMESHEET_ENTRIES = [];

    static PROJECT_API_CONFIG = {
        currentPage: 1,
        limit: 20
    }

    static TASK_API_CONFIG = {
        currentPage: 1,
        limit: 20
    }

    static EMPLOYEE_MAPPING_API_CONFIG = {
        currentPage: 1,
        limit: 20
    }

    static TIMESHEET_API_CONFIG = {
        currentPage: 1,
        limit: 20
    }

    static REPORTS_API_CONFIG = {
        currentPage: 1,
        limit: 20,
        fromDate: moment().startOf("month").startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate: moment().endOf("month").endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        searchString:''
    }
    static GROUING_REPORTS_API_CONFIG = {
        currentPage: 1,
        limit: 20,
        fromDate: moment().startOf("month").startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate: moment().endOf("month").endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        searchString:''
    }
    static REPORTS_CALENDER_API_CONFIG = {
        currentPage: 1,
        limit: 20,
        
        fromDate: moment().format('YYYY-MM-DD')+'T00:00:00Z',
        searchString:''
    }

    static getCustomers() {
        const URL = ApiConstants.URL.BOOKS.CONTACTS_BRIEF;
        return http.get(URL);
    }

    static getProjects(fetchPaginatedData) {
        const URL = ApiConstants.URL.TIMESHEET.PROJECT_LIST;

        const params = {
            "field": "updatedAt",
            "order": "desc"
        };

        if (fetchPaginatedData) {
            params["currentPage"] = TimesheetService.PROJECT_API_CONFIG.currentPage;
            params["limit"] = TimesheetService.PROJECT_API_CONFIG.limit;
        }

        return http.get(URL, { params: params });
    }

    static saveProject(payload) {
        return http.post(ApiConstants.URL.TIMESHEET.PROJECTS, payload);
    }

    static updateProject(payload) {
        return http.put(ApiConstants.URL.TIMESHEET.PROJECTS, payload);
    }

    static deleteProject(payload) {
        return http.delete(ApiConstants.URL.TIMESHEET.PROJECTS, { data: payload })
    }

    static getTasks(fetchPaginatedData) {
        const URL = ApiConstants.URL.TIMESHEET.TASK_LIST;

        const params = {
            "field": "updatedAt",
            "order": "desc"
        };

        if (fetchPaginatedData) {
            params["currentPage"] = TimesheetService.TASK_API_CONFIG.currentPage;
            params["limit"] = TimesheetService.TASK_API_CONFIG.limit;
        }

        return http.get(URL, { params: params });
    }

    static saveTask(payload) {
        return http.post(ApiConstants.URL.TIMESHEET.TASK, payload);
    }

    static updateTask(payload) {
        return http.put(ApiConstants.URL.TIMESHEET.TASK, payload);
    }

    static deleteTask(payload) {
        return http.delete(ApiConstants.URL.TIMESHEET.TASK, { data: payload })
    }

    static getEmployeeMappings(fetchPaginatedData) {
        const URL = ApiConstants.URL.TIMESHEET.EMPLOYEE_MAPPING_LIST;

        const params = {
            "field": "updatedAt",
            "order": "desc"
        };

        if (fetchPaginatedData) {
            params["currentPage"] = TimesheetService.EMPLOYEE_MAPPING_API_CONFIG.currentPage;
            params["limit"] = TimesheetService.EMPLOYEE_MAPPING_API_CONFIG.limit;
        }

        return http.get(URL, { params: params });
    }

    static saveEmployeeMapping(payload) {
        return http.post(ApiConstants.URL.TIMESHEET.EMPLOYEE_MAPPING, payload);
    }

    static updateEmployeeMapping(payload) {
        return http.put(ApiConstants.URL.TIMESHEET.EMPLOYEE_MAPPING, payload);
    }

    static deleteEmployeeMapping(payload) {
        return http.delete(ApiConstants.URL.TIMESHEET.EMPLOYEE_MAPPING, { data: payload })
    }

    static getTimesheetEntries(fetchPaginatedData) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.GET_TIMESHEET}`;

        const params = {
            "field": "createdAt",
            "order": "desc"
        };

        if (fetchPaginatedData) {
            params["currentPage"] = TimesheetService.TIMESHEET_API_CONFIG.currentPage;
            params["limit"] = TimesheetService.TIMESHEET_API_CONFIG.limit;
        }

        return http.get(URL, { params: params });
    }

    static saveTimesheetEntry(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.SAVE_TIMESHEET}`;
        return http.post(URL, payload);
    }

    static updateTimesheetEntry(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.UPDATE_TIMESHEET}`;
        return http.put(URL, payload);
    }

    static deleteTimesheetEntry(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.DELETE_TIMESHEET}`;
        return http.delete(URL, { data: payload });
    }

    static getReportData(config) {      
      const url = `${ApiConstants.URL.BASE+ApiConstants.URL.TIMESHEET.GET_REPORT}`;
      return http.get(url, {params: config});
    }

    static updateTimesheetStatus(param) {
        const url = `${ApiConstants.URL.BASE+ApiConstants.URL.TIMESHEET.UPDATE_TIMESHEET}/status`;
        return http
            .post(`${url}`,param);
    }

    static createInvoice(param) {
        const url = `${ApiConstants.URL.BASE+ApiConstants.URL.TIMESHEET.CREATE_INVOICE}`;
        return http.post(`${url}`, param);
    }

    static submitTimesheetEntry(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.SUBMIT}`;
        return http.post(URL, payload);
    }
    static getGroupingReportData(config) {      
        const url = `${ApiConstants.URL.BASE+ApiConstants.URL.TIMESHEET.GET_GROUP_REPORT}`;
        return http.get(url, {params: config});
    }
    static getCalenderReportData(config) {   
        const url = `${ApiConstants.URL.BASE+ApiConstants.URL.TIMESHEET.GET_ADMIN_CALENDER_REPORT}`;
        return http.get(url, {params: config});
    }
    static draftTimesheetEntry(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.TIMESHEET.DRAFT}`;
        return http.post(URL, payload);
    }
}

export default TimesheetService;
